<template>
  <CoreExpand
    :title="contactsHeading"
  >
    <div class="text-4 md:text-3">
      <RichTextRenderer
        :document="contacts"
        :node-renderers="nodeRenderer"
      />
    </div>
  </CoreExpand>
</template>

<script>
import { nodeRenderer } from '@utils';
import RichTextRenderer from 'contentful-rich-text-vue-renderer';

export default {
  name: 'TenantAreaContacts',

  components: {
    RichTextRenderer,
  },

  props: {
    contactsHeading: {
      type: String,
      default: '',
    },
    contacts: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    nodeRenderer,
  }),
};
</script>
